import React from "react";

import FilterOptionsHelper from "../../../../../lib/UniversalTable/CoreHelpers/FilterOptionsHelper";
import TrendStatusHelper from "../../../../../lib/UniversalTable/RendererHelpers/TrendStatusHelper";
import SquaberTooltip from "../../SquaberTooltip";
import { TrendStatusArrows } from "../components/TrendStatusArrows/TrendStatusArrows";

export default ({ value }) => {
  if (typeof value === "undefined" || value === null) {
    return null;
  }

  const renderedValue = TrendStatusHelper.render(value);

  if (!renderedValue) {
    return null;
  }

  return (
    <div className="number-renderer">
      <SquaberTooltip
        title={FilterOptionsHelper.getOptionTranslationKey(
          { attribute_name: "trend_status" },
          value
        )}
      >
        <span className="inline-flex">
          <TrendStatusArrows arrows={renderedValue} />
        </span>
      </SquaberTooltip>
    </div>
  );
};
